import React, { forwardRef } from 'react';

function PortalsContainerComponent(_props, ref) {
  return /*#__PURE__*/React.createElement("div", {
    id: "PolarisPortalsContainer",
    ref: ref
  });
}
const PortalsContainer = /*#__PURE__*/forwardRef(PortalsContainerComponent);

export { PortalsContainer };
